import Vue from 'vue'
import $ from 'webpack-zepto';
import baseView from "../../view/baseView";
import baseOptions from "../../view/baseOptions";
import supreme from '../../supreme'
import directive from '../directive'
const SupremePlugin={
  install( ){
    //Vue.extend(baseView);
    SupremePlugin.extendMethod();
    SupremePlugin.extendProp();
    SupremePlugin.extendDirective();
    SupremePlugin.extendFilter();
    SupremePlugin.extendOther();
  },
  //扩展指令
  extendDirective(){
    //require("../directive/infinite_scroll/index");
    directive.init();
  },
  //扩展过滤器
  extendFilter(){

  },
  //扩展方法
  extendMethod(){
    Vue.mixin(baseView);
  },
  //扩展属性
  extendProp(){
    $.extend(Vue.prototype,baseOptions);
  },
  //扩展其他
  extendOther(){
    (function(){

      // 扩展date lei
      Date.prototype.format = function (fmt) { //author: meizz
        var o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "h+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          "S": this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
      }
    })();
    window.addEventListener("online", ()=>{
      //console.log('online')
      supreme.pubHubus.$emit("online");
    }, false);
    window.addEventListener("offline", ()=>{
      supreme.pubHubus.$emit("offline");
    }, false);
  }
}
export default SupremePlugin;
